import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom"; // Import Link from react-router-dom if using React Router
import axios from "axios";
import StripeCheckout from "react-stripe-checkout";
import { createOrder } from "../../redux/features/order/orderSlice";
import { clearCart } from "../../redux/features/cart/cartSlice";

const OrderSummery = () => {
  const [paymentMethod, setPaymentMethod] = useState(false);
  const [token, setToken] = useState(null);
  const { cartTotal, cartItems, cartQuantity } = useSelector(
    (state) => state.cart
  );

  const { user } = useSelector((state) => state.auth);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const onToken = (token) => {
    setToken(token);
    // console.log(token);
  };

  useEffect(() => {
    const makeRequest = async () => {
      try {
        const res = await axios.post(
          "https://diucapstone1.onrender.com/api/checkout/payment",
          {
            tokenId: token.id,
            amount: cartTotal,
          }
        );
        // const createOrder = await create
        // console.log(res.data);

        if (res.data) {
          const orderData = {
            data: res.data,
            amount: cartTotal,
            email: token.email,
            items: cartItems,
            qunaity: cartQuantity,
          };
          dispatch(createOrder(orderData));
          dispatch(clearCart());
          navigate("/success");
        }
        // if(res.d){

        // }
      } catch (err) {
        console.log(err);
      }
    };
    token && makeRequest();
  }, [token]);

  const KEY =
    "pk_test_51ODy2jAga1Ski7sBteS78qpmGX9OAifhuP4UGi6EdZ96vamnPATAJGsSMyJLehzPomzUDw8KOohHG8c8EhZ1UIez00eBQU5X7s";
  const gotoPaymentHandler = () => {
    if (!user || user === null) {
      navigate("/login");
    } else {
      setPaymentMethod(true);
    }
  };

  const isAuthenticated = true;

  return (
    <div className="bg-white p-5 ml-2 mt-5 md:mt-0  min-w-[320px] rounded ">
      <h1 className="text-2xl ">Order Summary</h1>
      <div className="flex justify-between">
        <p className="text-slate-500">Subtotal (2items)</p> <p>৳ {cartTotal}</p>
      </div>
      <div className="flex justify-between">
        <p className="text-slate-500">Shipping Fee</p> <p>৳ 155</p>
      </div>
      {/* <div className="flex justify-between">
        <p className="text-slate-500">Shipping Fee Discount</p> <p>৳ -55</p>
      </div> */}
      <div className="flex justify-between">
        <p className="">Total</p>{" "}
        <p className="text-orange-500">৳ {cartTotal + 155}</p>
      </div>
      {!paymentMethod && (
        <button
          onClick={gotoPaymentHandler}
          className="bg-orange-500 w-full mt-3 text-white py-2 text-lg hover:bg-orange-600"
        >
          Proceed To Checkout
        </button>
      )}
      {paymentMethod && (
        <div>
          {/* <Link to={`${isAuthenticated ? "/cart/checkout/cod" : "/login"}`}>
            <button className="bg-orange-500 w-full mt-3 text-white py-2 text-lg hover:bg-orange-600">
              Cash On Delivery
            </button>
          </Link> */}

          <div>
            <StripeCheckout
              name="Wasi Store" // the pop-in header title
              description="Wasi Store is most popular shopping center at online " // the pop-in header subtitle
              image="https://wasi-1-1.vercel.app/about.png"
              billingAddress
              shippingAddress
              token={onToken}
              stripeKey={KEY}
              amount={cartTotal}
            >
              <button
                // onClick={makePayment}
                className="bg-orange-500 w-full mt-3 text-white py-2 text-lg hover:bg-orange-600"
              >
                Pay With Card
              </button>
            </StripeCheckout>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderSummery;
